module.exports = __webpack_public_path__ + "img/open-book.5d70405e.svg";